import { render, staticRenderFns } from "./DiagnosticHealth.vue?vue&type=template&id=47dbd5fc&"
import script from "./DiagnosticHealth.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHealth.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticHealth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47dbd5fc')) {
      api.createRecord('47dbd5fc', component.options)
    } else {
      api.reload('47dbd5fc', component.options)
    }
    module.hot.accept("./DiagnosticHealth.vue?vue&type=template&id=47dbd5fc&", function () {
      api.rerender('47dbd5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/DiagnosticHealth.vue"
export default component.exports